(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function initHeroSwipers() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initHeroSwipers, 200);
      return;
    }

    document.querySelectorAll('.hero-slider').forEach(function (heroSlider) {
      const container = heroSlider.querySelector('.hero-swiper');
      if (!container || container.swiper) return;

      const delaySeconds =
        parseInt(container.getAttribute('data-autoplay-delay')) || 5;

      const nextEl = container.querySelector('.swiper-button-next');
      const prevEl = container.querySelector('.swiper-button-prev');
      const paginationEl = container.querySelector('.swiper-pagination');

      const config = {
        loop: true,
        speed: 800,
        autoplay: {
          delay: delaySeconds * 1000,
          disableOnInteraction: false,
        },
        effect: 'slide',
      };

      if (paginationEl) {
        config.pagination = { el: paginationEl, clickable: true };
      }

      if (nextEl && prevEl) {
        config.navigation = { nextEl: nextEl, prevEl: prevEl };
      }

      new Swiper(container, config);
    });
  }

  initHeroSwipers();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
